module.exports = __webpack_public_path__ + "static/img/home_new15.3aa1994e.jpg";